export * from './terms-content.component';
